<template>
  <div class="row">
    <div class="col-4">
      <!-- Geração da escala de serviço -->
      <!-- Geração da escala de serviço -->
      <!-- Geração da escala de serviço -->

      <div>
        <b-row>
          <div class="ml-4 mt-2 mb-2 p-2">
            <b-button size="sm" @click="selectAllRows">Marcar todos</b-button>
          </div>

          <div class="mt-2 mb-2 p-2">
            <b-button size="sm" @click="clearSelected">Limpar todos</b-button>
          </div>
        </b-row>

        <!-- {{selected.map(lin => lin.id_linha)}} -->

        <!--
    <p>
      Selected Rows:<br>      {{ selected }}
    </p>
    -->

        <b-table
          small
          hover
          striped
          sticky-header="950px"
          :items="linhasescala"
          :fields="fields"
          :select-mode="selectMode"
          responsive="sm"
          ref="selectableTable"
          selectable
          @row-selected="onRowSelected"
        >
          <!-- Example scoped slot for select state illustrative purposes -->
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
        </b-table>
      </div>
    </div>

    <div class="col-8">
      <!-- Cadastro de tabelas-->
      <!-- Cadastro de tabelas-->
      <!-- Cadastro de tabelas-->
      <div class="atividades-rfilancamentos ml-4 mr-4">
        <b-form>
          <label for="input-filial">Empresa</label>
          <b-row id="id-encerramento" cols="12" class="mt-2 mb-2 p-2">
            <!--empresa -->
            <b-col cols="4">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="empresa"
                  v-model="tabela.id_empresa"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                  @change="loadFiliais()"
                >
                </b-form-select>
              </div>
            </b-col>

            <!-- filial-->
            <b-col cols="3">
              <label for="input-filial">Filial</label>
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_filial"
                  required
                  :options="filiais"
                  class="mb-3"
                  text-field="filial"
                >
                </b-form-select>
              </div>
            </b-col>

            <!--Tipo de dia -->
            <b-col cols="2">
              <label for="input-filial">Tipo de Dia</label> --
              <div>
                <b-form-select
                  id="filial"
                  v-model="tabela.id_dia"
                  @change="loadLinhas"
                  required
                  :options="tipodias"
                  class="mb-3"
                  text-field="dia"
                >
                </b-form-select>
              </div>
            </b-col>

            <LoadingModal v-if="isLoading" />

            <!-- Vigência -->
            <b-col cols="2">
              <div>
                <label for="datepicker-placeholder">Data da escala</label>

                <b-form-datepicker
                  id="datepicker-placeholder"
                  required
                  v-model="tabela.dt_servico"
                  @input="loadEscalaGerada()"
                  placeholder="Data do serviço"
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>
          </b-row>

          <!-- Gravar tabela -->
          <b-row>
            <!--
        <b-col cols="10">
          <div >    
          <b-progress class="mt-3 mp-3" :max="barra_limite">
            <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
          </b-progress>
          </div>
        </b-col>
        -->

            <b-col cols="12" class="mt-0">
              <b-button
                size="sm"
                id="btn-pesquisar"
                variant="success"
                block
                class="mr-2 mt-2"
                @click="postEscalaServicoDiario()"
              >
                Gerar Escala
              </b-button>
            </b-col>
          </b-row>

          <!--tbl de dados -->
          <b-table
            id="tbltabelas"
            class="m-3"
            small
            hover
            striped
            sticky-header="818px"
            :items="tabelasgeradas"
            :fields="tabelasgrid"
          >
            <template slot="cell(actions)" slot-scope="data">
              <b-button
                @click="editTabela(data.item)"
                v-b-modal.modal-multi-corretiva
                title="Editar tabela"
                size="sm"
                variant="success"
                class="mr-2"
              >
                <i class="fa fa-exclamation-circle"></i>
              </b-button>
            </template>
          </b-table>
        </b-form>

        <div class="d-flex justify-content-center mb-3">
          <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "PlanejamentoEscalaModelo",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];
      // const values = Object.values(obj);
      valores = this.tabelas.filter((item) => {
        return (
          item.tabela.indexOf(this.search) > -1 ||
          item.carro.indexOf(this.search) > -1 ||
          item.motorista1.indexOf(this.search) > -1
        );
      });
      return valores;
    },
  },

  data: function () {
    return {
      isLoading: false,
      mode: "save",
      carregando: false,
      atualizando: false,

      // 15/07/2023 as 12:24h
      empresas: [],
      tabela: {},
      tabelas: [],
      tabelasgeradas: [],
      filiais: [],
      tipodias: [],
      periodos: [],
      sentidos: [],
      pontos: [],
      veiculos: [],
      motorista1: [],
      motorista2: [],
      cobrador1: [],
      cobrador2: [],
      veiculo: "",
      search: "",
      quadrohorario: [],
      quadrohorarios: [],
      legendas: [],

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      // seleção das linhas
      linhasescala: [],
      selectMode: "multi",
      selected: [],

      fields: [
        { key: "selected", label: "Seleção", sortable: true },
        { key: "id_linha", label: "Id", sortable: true },
        { key: "linha", label: "Linha", sortable: true },
        {
          key: "dt_vigencia",
          label: "Vigência",
          sortable: true,
          formatter: (value, key, linhasescala) => {
            return moment(linhasescala.dt_vigencia)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
      ],

      tabelasgrid: [
        { key: "id_escaladiaria", label: "Sequencial", sortable: true },
        { key: "linha", label: "Linha", sortable: true },
        { key: "tabela", label: "Tabela", sortable: true },
        { key: "servico_ini", label: "jornada_inicio", sortable: true },
        { key: "servico_ter", label: "jornada_termino", sortable: true },
        { key: "carroprogramado", label: "carro", sortable: true },
        { key: "motprogramado", label: "Motorista", sortable: true },
        { key: "cobprogramado", label: "Cobrador", sortable: true },
        {
          key: "dt_cadastro",
          label: "Geração",
          sortable: true,
          formatter: (value, key, tabelasgeradas) => {
            return moment(tabelasgeradas.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: " Alteração",
          sortable: true,
          formatter: (value, key, tabelasgeradas) => {
            return moment(tabelasgeradas.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2);
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2);
    },

    //barra de progresso
    ready() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          //this.loadRfiLancamentos()
        }
      }, 1000);
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    loadEmpresa() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .get(url, { params })
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadLinhas() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.tabela.id_filial}`,
        id_dia: `${this.tabela.id_dia}`,
        origem: "ESCALADIARIA",
      };

      // Esta condição verifica se qualquer um dos parâmetros é falsy,
      // o que inclui 'undefined', 'null' e strings vazias.
      if (
        !params.id_empresa ||
        !params.id_filial ||
        !params.id_dia ||
        !params.psg
      ) {
        this.showToast(
          "Por favor, preencha todos os campos obrigatórios (Empresa, Filial, Dia, PSG).",
          "error"
        );
        return; // Interrompe a execução
      }

      const url = `${baseApiUrl}/planejamento/linha`;
      axios
        .get(url, { params })
        .then((res) => {
          this.linhasescala = res.data.map((lin) => {
            return { ...lin, value: lin.id_linha, linha: lin.linha };
          });
        })
        .catch(showError);
    },

    loadTipoDia() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/tipodia`;
      axios
        .get(url, { params })
        .then((res) => {
          // Primeiro, filtre os dados para remover os IDs 5 e 6
          this.tipodias = res.data
            .filter((td) => td.id !== 5 && td.id !== 6) // <--- Filtra IDs 5 e 6
            .map((td) => {
              return { ...td, value: td.id, dia: td.dia };
            });
        })
        .catch(showError);
    },

    loadPeriodo() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/periodo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.periodos = res.data.map((per) => {
            return { ...per, value: per.id, periodo: per.periodo }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadSentido() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/sentido`;
      axios
        .get(url, { params })
        .then((res) => {
          this.sentidos = res.data.map((se) => {
            return { ...se, value: se.id, sentido: se.sentido }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadVeiculo() {
      let corpo = {
        id_empresa: `${this.user.id_empresa}`,
        prefixo: `${this.tabela.id_carro}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.veiculos = res.data.map((lin) => {
            return { ...lin };
          });
        })
        .catch(showError);
    },

    loadLocal() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/local`;
      axios
        .get(url, { params })
        .then((res) => {
          this.pontos = res.data.map((po) => {
            return { ...po, value: po.id_ponto, ponto: po.ponto }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadBuscaMotorista1() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_motorista1}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.motorista1 = res.data.map((mt1) => {
            return { ...mt1 };
          });
        })
        .catch(showError);
    },

    loadBuscaMotorista2() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_motorista2}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.motorista2 = res.data.map((op) => {
            return { ...op, value: op.id_funcionario, funcao: op.funcao }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadBuscaCobrador1() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_cobrador1}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.cobrador1 = res.data.map((op) => {
            return { ...op, value: op.id_funcionario, funcao: op.funcao }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadBuscaCobrador2() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmet
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.tabela.id_cobrador2}`,
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.cobrador2 = res.data.map((op) => {
            return { ...op, value: op.id_funcionario, funcao: op.funcao }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    postTabela() {
      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id: `${[this.tabela.id]}`,
        id_empresa_grupo: `${[this.user.id_empresa]}`,
        id_empresa: `${[this.tabela.id_empresa]}`,
        id_filial: `${[this.tabela.id_filial]}`,
        id_linha: `${[this.tabela.id_linha]}`,
        tabela: `${[this.tabela.tabela]}`,
        id_tipo: `${[this.tabela.id_tipo]}`,
        id_periodo: `${[this.tabela.id_periodo]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        jornada_inicio: `${this.tabela.jornada_inicio}`,
        jornada_termino: `${[this.tabela.jornada_termino]}`,
        linha_inicio: `${[this.tabela.linha_inicio]}`,
        linha_termino: `${[this.tabela.linha_termino]}`,
        refeicao_inicio: `${[this.tabela.refeicao_inicio]}`,
        refeicao_termino: `${[this.tabela.refeicao_termino]}`,
        id_sentido_inicio: `${[this.tabela.id_sentido_inicio]}`,
        id_sentido_termino: `${[this.tabela.id_sentido_termino]}`,
        id_carro: `${[this.veiculos.map((ve) => ve.id_veiculo)]}`,
        id_motorista1: `${[this.motorista1.map((mt1) => mt1.id_funcionario)]}`,
        id_motorista2: `${[this.motorista2.map((mt2) => mt2.id_funcionario)]}`,
        id_motorista_pegada: `${[this.tabela.id_motorista_pegada]}`,
        id_motorista_largada: `${[this.tabela.id_motorista_largada]}`,
        entrega_feria: `${[this.tabela.entrega_feria]}`,
        motorista_tempo_minuto: `${[this.tabela.motorista_tempo_minuto]}`,
        cobrador_tempo_minuto: `${[this.tabela.cobrador_tempo_minuto]}`,
        noturno: `${[this.tabela.noturno]}`,
        tem_cobrador: `${[this.tabela.tem_cobrador]}`,
        dt_vigencia: `${[this.tabela.dt_vigencia]}`,
        status: `${[this.tabela.status]}`,
        id_funcionario_cadastro: `${[this.user.id_funcionario]}`,
        id_funcionario_alteracao: `${[this.user.id_funcionario]}`,
        id_identificador: `${[this.tabela.id_identificador]}`, // id legenda da programação
        id_cobrador1: `${[this.cobrador1.map((cb1) => cb1.id_funcionario)]}`,
        id_cobrador2: `${[this.cobrador2.map((cb2) => cb2.id_funcionario)]}`,
        id_cobrador_pegada: `${[this.tabela.id_cobrador_pegada]}`,
        id_cobrador_largada: `${[this.tabela.id_cobrador_largada]}`,
      };

      const url = `${baseApiUrl}/planejamento/tabela`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.resetTabela();
          /*
                this.carregando = false;
                //this.resetTabela()
                this.pontos = res.data.map(tbl => {
                  return { id: tbl.id }                  
                })
                */
        })
        .catch(showError);
    },

    loadTabelas() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        id_linha: `${this.tabela.id_linha}`,
      };
      const url = `${baseApiUrl}/planejamento/tabelamodelo`;
      axios
        .post(url, { params })
        .then((res) => {
          this.tabelas = res.data.map((tabs) => {
            return { ...tabs };
          });
        })

        .catch(showError);
    },

    loadEscalaGerada() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${[this.tabela.id_filial]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        dt_servico: `${this.tabela.dt_servico}`,
      };
      const url = `${baseApiUrl}/planejamento/escalagerada`;
      axios
        .get(url, { params })
        .then((res) => {
          this.tabelasgeradas = res.data.map((tabs) => {
            return { ...tabs };
          });
          this.isLoading = false; // Desative o indicador de carregamento
        })
        .catch(showError);
    },

    /////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////
    /// QUADRO DE HORÁRIOS

    loadLegenda() {
      let params = {
        psg: `${this.user.psg}`,
        id_empresa: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/legenda`;
      axios
        .get(url, { params })
        .then((res) => {
          this.legendas = res.data.map((le) => {
            return { ...le, value: le.id, legenda: le.legenda }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    postQuadroHorario() {
      let corpo = {
        id: `${[this.quadrohorario.id]}`,
        id_tabela: `${[this.tabela.id]}`,
        id_empresa: `${[this.tabela.id_empresa]}`,
        id_filial: `${[this.tabela.id_filial]}`,
        id_linha: `${[this.tabela.id_linha]}`,
        id_dia: `${[this.tabela.id_dia]}`,
        chegada: `${this.quadrohorario.chegada}`,
        chegada_virada_do_dia: `${this.quadrohorario.chegada_virada_do_dia}`,
        saida: `${this.quadrohorario.saida}`,
        saida_virada_do_dia: `${this.quadrohorario.saida_virada_do_dia}`,
        id_legenda: `${[this.quadrohorario.id_legenda]}`,
        id_funcionario_cadastro: `${[this.user.id_funcionario]}`,
        id_funcionario_alteracao: `${[this.user.id_funcionario]}`,
        id_sentido: `${[this.quadrohorario.id_sentido]}`, // id legenda da programação
        ponto_id: `${[this.quadrohorario.ponto_id]}`, // id legenda da programação
        status: `${[this.quadrohorario.status]}`, // id legenda da programação
        dt_vigencia: `${[this.tabela.dt_vigencia]}`,
      };

      const url = `${baseApiUrl}/planejamento/escala/quadrohorario`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess();
          this.resetQuadroHorario();
          this.loadQuadroHorario();
        })
        .catch(showError);
    },

    loadQuadroHorario() {
      let corpo = {
        id_tabela: `${[this.tabela.id]}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/quadrohorario/busca`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess();
          //this.quadrohorarios = res.data.map(qh => {              return { ... qh}            }            )
        })
        .catch(showError);
    },

    postEscalaServicoDiario() {
      // Ative o indicador de carregamento
      this.isLoading = true;

      // 1. Prepara os dados do corpo da requisição.
      //    Garanta que os valores que deveriam vir de seleções ou inputs
      //    estão sendo corretamente populados em 'this.tabela' e 'this.user'.
      //    A conversão de id_linha para string separada por vírgulas já está correta aqui.
      let idLinhasSelecionadas = this.selected.map((lin) => lin.id_linha);
      let corpo = {
        psg: this.user.psg,
        id_empresa: this.tabela.id_empresa,
        id_filial: this.tabela.id_filial,
        id_dia: this.tabela.id_dia,
        dt_servico: this.tabela.dt_servico,
        id_funcionario: this.user.id_funcionario,
        id_linha: idLinhasSelecionadas.join(","),
      };

      // --- Validação dos Campos Obrigatórios ---
      // A ordem de verificação é importante: primeiro os campos individuais, depois o array de linhas.

      // Verifica se algum dos campos principais está vazio/undefined/null.
      // O uso de `!` é ideal para pegar `undefined`, `null` e `""` (string vazia).
      if (
        !corpo.psg ||
        !corpo.id_empresa ||
        !corpo.id_filial ||
        !corpo.id_dia ||
        !corpo.dt_servico ||
        !corpo.id_funcionario
      ) {
        this.isLoading = false; // Desativa o carregamento
        this.showToast(
          "Por favor, preencha todos os campos obrigatórios.",
          "error"
        );
        return; // Impede a execução do restante da função
      }

      // Verifica se o array original de 'idLinhasSelecionadas' está vazio.
      // Isso cobre o caso de não ter nenhuma linha selecionada.
      if (!idLinhasSelecionadas || idLinhasSelecionadas.length === 0) {
        this.isLoading = false; // Desativa o carregamento
        this.showToast("Por favor, selecione pelo menos uma linha.", "error");
        return; // Impede a execução
      }
      // --- Fim da Validação ---

      // Se todas as validações passaram, procede com a requisição API
      const url = `${baseApiUrl}/planejamento/escala/diaria`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.$toasted.global.defaultSuccess(); // Confirmação de sucesso
          this.carregando = false; // Pode ser 'isLoading' dependendo da sua lógica global
          this.loadEscalaGerada(); // Recarrega os dados após a operação
        })
        .catch(showError); // Lida com erros da requisição
    },

    ///

    editTabela(tabela) {
      this.tabela = { ...tabela };
    },

    editQuadroHorario(quadrohorario) {
      this.quadrohorario = { ...quadrohorario };
    },

    resetTabela() {
      this.tabela.cobrador1 = "";
      this.tabela.id = "";
      this.tabela.tabela = "";
      this.tabela.jornada_inicio = "";
      this.tabela.jornada_termino = "";
      this.tabela.linha_inicio = "";
      this.tabela.linha_termino = "";
    },

    resetQuadroHorario() {
      this.quadrohorario.id = "";
      this.quadrohorario.chegada = "";
      this.quadrohorario.saida = "";
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadTipoDia();
    this.loadPeriodo();
    this.loadSentido();
    this.loadLocal();
    this.loadLegenda();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#rfilancamentos {
  font-size: 0.9em;
  text-align: center;
}
</style>